import { formatSongLength } from '../masterFile';

/** `m:ss` for the elapsed and total time. A missing time is `–:––`. */
export function formatPlayerTime(seconds: number | null): string {
  if (seconds === null || !Number.isFinite(seconds) || seconds < 0) {
    return '–:––';
  }
  return formatSongLength(Math.floor(seconds));
}

/** Where the hook mark sits on the bar, from 0 to 1. Null when the hook or the length is not known. */
export function hookFraction(hookStartSec: number | null, durationSec: number | null): number | null {
  if (hookStartSec === null || durationSec === null || durationSec <= 0) {
    return null;
  }
  return Math.min(1, Math.max(0, hookStartSec / durationSec));
}

/** The played part of the bar, from 0 to 1. */
export function playedFraction(positionSec: number, durationSec: number | null): number {
  if (durationSec === null || durationSec <= 0) {
    return 0;
  }
  return Math.min(1, Math.max(0, positionSec / durationSec));
}

/** The file type of a master from its name, in capitals (`WAV`). Empty when the name has no extension. */
export function masterFileType(name: string): string {
  const dot = name.lastIndexOf('.');
  if (dot <= 0 || dot === name.length - 1) {
    return '';
  }
  return name.slice(dot + 1).toUpperCase();
}
